module.exports = __webpack_public_path__ + "img/aibee-logo.b6572aa9.webp";